/**
 * Directiva utilizada para ver y añadir inspecciones a las incidencias
 */
EntidadEnvioDetallesDirectiva.$inject = ['lang'];
export default function EntidadEnvioDetallesDirectiva(lang) {
    return {
        restrict: 'AE',
        scope: {
            'incidenciaId': '=',
            'tareaId': '='
        },
        template: require('./entidadesEnviosDetalles.html'),
        controller: 'EntidadEnvioDetallesCtrl as entEnvDet',
        bindToController: true
    }
}